/** @jsxRuntime classic */
/** @jsx jsx */

import { css, jsx } from '@emotion/core';
import { labelStyles } from '@zapier/style-encapsulation';
import { Button, BrandButton } from '@zapier/design-system';
import { useAvroTracking } from 'tracking';
import { getLinkTarget } from 'utils/getLinkTarget';

export interface EmbeddedButtonProps {
  alignment?: string | null;
  color?: string | null;
  text: string;
  url: string;
}

const Styles = labelStyles('EmbeddedButton', {
  root: (alignment: EmbeddedButtonProps['alignment']) =>
    css({
      width: '100%',
      maxWidth: '1170px',
      padding: '20px 0',
      textAlign:
        alignment === 'left' || alignment === 'center' || alignment === 'right'
          ? alignment
          : 'center',
    }),
});

export function EmbeddedButton(props: EmbeddedButtonProps) {
  const { emitCTAClickEvent } = useAvroTracking();

  const handleClick = () => {
    emitCTAClickEvent({
      interaction_raw_text: props.text,
      destination_url_address: props.url,
    });
  };

  const sharedProps = {
    children: props.text,
    href: props.url,
    onClick: handleClick,
    target: getLinkTarget(props.url),
  };

  return (
    <div css={Styles.root(props.alignment)}>
      {props.color === 'brand' ? (
        <BrandButton {...sharedProps} />
      ) : (
        <Button
          {...sharedProps}
          color={
            props.color === 'primary' || props.color === 'primary-alt'
              ? props.color
              : 'primary'
          }
        />
      )}
    </div>
  );
}
